import {DOCUMENTS} from '../../actions/documents/documentsActionsTypes';

const INITIAL_STATE = {
    documents: {
        items: [], pagination: {
            current_page: 1, last_page: 1, per_page: 50, total: 0,
        }, loading: false,
    },
    estimates: {
        items: [], pagination: {
            current_page: 1, last_page: 1, per_page: 50, total: 0,
        }, loading: false,
    },
    drawings: {
        items: [],
        pagination: {
            current_page: 1, last_page: 1, per_page: 50, total: 0,
        }, loading: false,
    },
    filterQueryCompanies: 'all',
    searchQueryCompanies: '',
    singleDocument: {},
    singleDocumentLoading: true,
    documentTabCompany: '1',
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case DOCUMENTS.SET_DOCUMENT_TAB:
            return {
                ...state, documentTabCompany: action.payload,
            }
        case DOCUMENTS.GET_DOCUMENTS:
            const needReloadDocs = action.payload.request.needReload

            return {
                ...state, documents: {
                    ...state.documents, loading: needReloadDocs,
                },
            };
        case DOCUMENTS.GET_DOCUMENTS_SUCCESS:
            const pagination = action.payload.data.meta ? action.payload.data.meta : INITIAL_STATE.documents.pagination
            return {
                ...state, documents: {
                    items: action.payload.data.data, pagination: pagination, loading: false,
                },
            };
        case DOCUMENTS.GET_DOCUMENTS_FAIL:
            return {
                ...state, documents: {
                    items: [], pagination: INITIAL_STATE.documents.pagination, loading: false,
                },
            };
        case DOCUMENTS.ADD_DOCUMENTS:
            return {
                ...state, documents: {
                    ...state.documents,
                    loading: false,
                },
            }
        case DOCUMENTS.ADD_DOCUMENTS_SUCCESS:
            return {
                ...state, documents: {
                    ...state.documents,
                    items: [...state.documents.items, ...action.payload.data.data],
                    pagination: action.payload.data.meta,
                    loading: false,
                },
            }
        case DOCUMENTS.ADD_DOCUMENTS_FAIL:
            return {
                ...state, documents: {
                    ...state.documents, loading: false,
                },
            };
        // ESTIMATES
        case DOCUMENTS.GET_ESTIMATES:
            return {
                ...state, estimates: {
                    ...state.estimates, loading: true,
                },
            };
        case DOCUMENTS.GET_ESTIMATES_SUCCESS:
            const paginationEstimates = action.payload.data.meta ? action.payload.data.meta : INITIAL_STATE.estimates.pagination

            return {
                ...state, estimates: {
                    items: action.payload.data.data, paginationEstimates, loading: false,
                },
            };
        case DOCUMENTS.GET_ESTIMATES_FAIL:
            return {
                ...state, estimates: {
                    items: [], pagination: INITIAL_STATE.estimates.pagination, loading: false,
                },
            };
        case DOCUMENTS.ADD_ESTIMATES:
            return {
                ...state, estimates: {
                    items: [...state.estimates.items, ...action.payload.data.data],
                    pagination: action.payload.data.meta,
                    loading: false,
                },
            };

        // DRAWINGS
        case DOCUMENTS.GET_DRAWING:
            const needReload = action.payload.request.needReload

            return {
                ...state, drawings: {
                    ...state.drawings, loading: needReload,
                },
            };
        case DOCUMENTS.GET_DRAWING_SUCCESS:
            const paginationDrawing = action.payload.data.meta ? action.payload.data.meta : INITIAL_STATE.drawings.pagination

            return {
                ...state, drawings: {
                    items: action.payload.data.data, pagination: paginationDrawing, loading: false,
                },
            };
        case DOCUMENTS.GET_DRAWING_FAIL:
            return {
                ...state, drawings: {
                    items: [], pagination: INITIAL_STATE.drawings.pagination, loading: false,
                },
            };
        case DOCUMENTS.ADD_DRAWING:
            return {
                ...state, drawings: {
                    ...state.drawings,
                    loading: false,
                },
            }
        case DOCUMENTS.ADD_DRAWING_SUCCESS:
            return {
                ...state, drawings: {
                    ...state.drawings,
                    items: [...state.drawings.items, ...action.payload.data.data],
                    pagination: action.payload.data.meta,
                    loading: false,
                },
            }
        case DOCUMENTS.ADD_DRAWING_FAIL:
            return {
                ...state, drawings: {
                    ...state.drawings, loading: false,
                },
            };
        case DOCUMENTS.RESET_ALL_DOCS:
            return {
                ...state,
                documents: {
                    items: [], pagination: {
                        current_page: 1, last_page: 1, per_page: 50, total: 0,
                    }, loading: false,
                },
                estimates: {
                    items: [], pagination: {
                        current_page: 1, last_page: 1, per_page: 50, total: 0,
                    }, loading: false,
                },
                drawings: {
                    items: [], pagination: {
                        current_page: 1, last_page: 1, per_page: 50, total: 0,
                    }, loading: false,
                },
            };
        case DOCUMENTS.RESET_ALL_FILTERS:
            return {
                ...state,
                documents: {
                    items: [], pagination: {
                        current_page: 1, last_page: 1, per_page: 50, total: 0,
                    }, loading: false,
                },
                estimates: {
                    items: [], pagination: {
                        current_page: 1, last_page: 1, per_page: 50, total: 0,
                    }, loading: false,
                },
                drawings: {
                    items: [], pagination: {
                        current_page: 1, last_page: 1, per_page: 50, total: 0,
                    }, loading: false,
                },
                documentTabCompany: '1',
                filterQueryCompanies: 'all',
                searchQueryCompanies: ''
            }
        case DOCUMENTS.SET_FILTER_QUERY:
            return {
                ...state,
                filterQueryCompanies: action.payload,
            };
        case DOCUMENTS.SET_SEARCH_QUERY:
            return {
                ...state,
                searchQueryCompanies: action.payload,
            };
        case DOCUMENTS.GET_SINGLE_DOCUMENT:
            return {...state, singleDocument: [], singleDocumentLoading: true};
        case DOCUMENTS.GET_SINGLE_DOCUMENT_SUCCESS:
            return {...state, singleDocument: action.payload.data.data, singleDocumentLoading: false};
        case DOCUMENTS.GET_SINGLE_DOCUMENT_FAIL:
            return {...state, singleDocument: {}, singleDocumentLoading: true};
        case DOCUMENTS.RESET_SINGLE_DOC:
            return {...state, singleDocument: {}, singleDocumentLoading: true};
        default:
            return state;
    }
}
